import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const AvatarContainer = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
`;

const Ring = styled(motion.div)`
  position: absolute;
  inset: -4px;
  border: 2px solid rgba(0, 255, 136, 0.3);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
`;

const Core = styled.div`
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at center,
    rgba(0, 255, 136, 0.4) 0%,
    rgba(0, 255, 136, 0.1) 60%,
    transparent 100%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::after {
    content: '';
    width: 30%;
    height: 30%;
    background: #00ff88;
    border-radius: 50%;
    filter: blur(4px);
  }
`;

export const NeuraAvatar: React.FC<{ isSpeaking: boolean }> = ({ isSpeaking }) => {
  const variants = {
    speaking: {
      scale: [1, 1.2, 1],
      opacity: [0.3, 0.7, 0.3],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "linear"
      }
    },
    silent: {
      scale: 1,
      opacity: 0,
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <AvatarContainer>
      <Ring
        variants={variants}
        animate={isSpeaking ? "speaking" : "silent"}
      />
      <Core />
    </AvatarContainer>
  );
}; 